import styled, { css } from "styled-components";
import { commonCSS } from "@xbox/social-views";

// common web image styles
export const ImageCircle = styled.div`${css`${commonCSS.imgCircle}`}`;
export const ImageFade = styled.img`${css`${commonCSS.imgFade}`}`;
